module.exports = __webpack_public_path__ + "img/banner3-2.8fb01bfd.jpg";